import type { TInputFileInstance } from './InputFile';

/**
 * @description This class is not intended to have a separate DOM representation.
 *
 * @param AjaxForm Base widget for extending
 * @returns AjaxFormWithRecaptcha Form widget
 */
function AjaxFormWithAttachmentClassCreator(AjaxForm: import('widgets/forms/AjaxForm').TAjaxForm) {
    /**
     * @category widgets
     * @subcategory forms
     * @class AjaxFormWithAttachment
     * @augments AjaxForm
     * @classdesc Represents AjaxFormWithAttachment component with next features:
     * Convert files to base64, sanitize name and verify mime types.
     */
    class AjaxFormWithAttachment extends AjaxForm {
        /**
         * @description Handles submit Form with File Input elements
         * @returns Promise object represents server response
         */
        handleSubmit() {
            const inputFilesInstance = this.items.find(item => item?.id?.includes('inputFiles')) as TInputFileInstance;
            const attachmentsPayloadInput = this.items.find(item => item?.id?.includes('attachmentPayload'));

            if (inputFilesInstance && inputFilesInstance.length > 0) {
                return inputFilesInstance.getFilesPayload().then(payloadBase64 => {
                    const inputHiddenAttachment = attachmentsPayloadInput?.ref('field').get(0) as HTMLInputElement;

                    inputHiddenAttachment.value = JSON.stringify(payloadBase64);

                    return super.handleSubmit();
                });
            }

            return super.handleSubmit();
        }
    }

    return AjaxFormWithAttachment;
}

export type TAjaxFormWithAttachment = ReturnType<typeof AjaxFormWithAttachmentClassCreator>;

export type TAjaxFormWithAttachmentInstance = InstanceType<TAjaxFormWithAttachment>;

export default AjaxFormWithAttachmentClassCreator;
